'use client';

import classnames from 'classnames';
import { useIntl } from 'react-intl';
import IconButton from '@alltrails/denali/components/IconButton';
import Bookmark from '@alltrails/denali/icons/Bookmark';
import BookmarkFilled from '@alltrails/denali/icons/BookmarkFilled';
import Heart from '@alltrails/denali/icons/Heart';
import HeartFilled from '@alltrails/denali/icons/HeartFilled';
import { useExperiments } from '@alltrails/experiments';
import styles from './styles/styles.module.scss';

// https://www.figma.com/file/mh7ECfwLfHr8jTIaAYOS80/Trail-Cards-Handoff?type=design&node-id=6-22393&mode=design&t=owxmYpF8bihcHicv-0
type BookmarkButtonProps = {
  isSelected: boolean;
  onClick: (e: React.MouseEvent<HTMLElement>) => void;
  className?: string;
};

const BookmarkButton = ({ isSelected, onClick, className }: BookmarkButtonProps) => {
  const intl = useIntl();
  const experiments = useExperiments();
  const useHeartIcon = experiments['web-saved-heart-icon']?.value === 'on';

  const IconComponent = useHeartIcon
    ? (isSelected ? HeartFilled : Heart)
    : (isSelected ? BookmarkFilled : Bookmark);

  const title = useHeartIcon
    ? (isSelected ? intl.formatMessage({ defaultMessage: 'Saved' }) : intl.formatMessage({ defaultMessage: 'Save' }))
    : (isSelected ? intl.formatMessage({ defaultMessage: 'Remove from list' }) : intl.formatMessage({ defaultMessage: 'Add to list' }));

  return (
    <IconButton
      icon={{ Component: IconComponent, color: '--color-brand-onyx' }}
      size="sm"
      aria-label={title}
      className={classnames(styles.container, { [styles.isSelected]: isSelected }, className)}
      onClick={onClick}
      testId={title}
      title={title}
      type="button"
    />
  );
};

export default BookmarkButton;
